<template>
  <div class="tooth">
    <v-select
      append-icon=""
      class="tooth__diagnosis-select"
      hide-details
      item-text="description"
      item-value="name"
      v-bind:items="diagnosesList"
      v-model="upper">
      <template v-slot:selection="{ item }">
        <div class="tooth__cell">{{item.name}}</div>
      </template>
    </v-select>
    <v-select
      append-icon=""
      class="tooth__diagnosis-select"
      hide-details
      item-text="description"
      item-value="name"
      v-bind:items="diagnosesList"
      v-model="lower">
      <template v-slot:selection="{ item }">
        <div class="tooth__cell">{{item.name}}</div>
      </template>
    </v-select>
  </div>
</template>

<script>

export default {
  name: 'ExaminedTooth',
  data() {
    return {
      upper: this.diagnosisUpper,
      lower: this.diagnosisLower,
    };
  },
  props: {
    /**
     * @description Список диагнозов.
     * @type {any[]}
     */
    diagnosesList: { type: Array, required: true },
    /**
     * @description Диагноз нижней части зуба.
     * @type {string}
     */
    diagnosisLower: { type: String, required: true },
    /**
     * @description Диагноз верхней части зуба.
     * @type {string}
     */
    diagnosisUpper: { type: String, required: true },
  },
  watch: {
    upper(value) {
      this.$emit('change', { part: 'upper', value });
    },
    lower(value) {
      this.$emit('change', { part: 'lower', value });
    },
  },
};
</script>

<style scoped lang="scss">
.tooth {
  display: flex;
  flex-direction: column;
  gap: 2px;
  &__diagnosis-select {
    margin: 0 !important;
    padding: 0 !important;
    &::v-deep > .v-input__control > .v-input__slot::before,
    &::v-deep > .v-input__control > .v-input__slot::after {
      content: none !important;
    }
  }
  &__cell {
    background-color: white;
    border-radius: 3px;
    cursor: pointer;
    font-size: 28px;
    font-weight: 300;
    height: 44px;
    line-height: 44px;
    text-align: center;
    width: 44px;
  }
}
@media print {
  .tooth__cell {
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 24px;
  }
}
</style>
